export class AssetType {
    id: number;
    name: string;
}
export enum AssetTypes {
    walt = 4,
    roip = 36,
}